/**
 * Content Library — shared tag API.
 *
 * Type-ahead suggestions for the loose, admin-defined tags attached to any
 * Content Library asset. Backed by `GET /api/content-library/tags?q=`, which
 * returns distinct existing tags (the admin's own + shared) matching a prefix
 * so admins reuse labels instead of re-typing near-duplicates.
 */

import { API_URL } from '../../config';

/** Suggest existing tags matching `query` (prefix match). Never throws. */
export async function suggestTags(query: string): Promise<string[]> {
  try {
    const response = await fetch(
      `${API_URL}/api/content-library/tags?q=${encodeURIComponent(query)}`,
      { credentials: 'include' },
    );
    if (!response.ok) return [];
    const data = await response.json();
    return (data.tags ?? []) as string[];
  } catch {
    return [];
  }
}
